import type { OnChange } from '@monaco-editor/react';
import Editor from '@monaco-editor/react';
import React from 'react';

interface CodeContentProps {
  content: string;
  onChange?: OnChange;
  readOnly?: boolean;
}

export const CodeContent: React.FC<CodeContentProps> = ({ content, onChange, readOnly = true }) => {
  return (
    <div className="h-full overflow-hidden">
      <Editor
        height="100%"
        value={content}
        language="json"
        theme="vs-dark"
        onChange={onChange}
        options={{
          readOnly,
          wordWrap: 'on',
          lineNumbers: 'off',
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
        }}
      />
    </div>
  );
};
